export const severities = ["info", "warning", "error", "critical"] as const;
